import { render } from "./HeaderLinksSectionJP.vue?vue&type=template&id=54161b2b&scoped=true"
const script = {}

import "./HeaderLinksSectionJP.vue?vue&type=style&index=0&id=54161b2b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54161b2b"]])

export default __exports__